import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { BetSummary } from '../../../Reports/summary';
import { EOD } from '../../../Reports/eod';
import { MTNAnalysis } from '../../../Reports/mtnanalysis';
import { GamingIncome } from '../../../Reports/gameincome';
import { RevenueChannel } from '../../../Reports/revenuechannel';
import { WithdrawalSummary } from '../../../Reports/withdawals';
import { CustomerSubscription } from '../../../Reports/customersubscription';
import { TimePlayed } from '../../../Reports/timeplayed';
import { DepositAttempts } from '../../../Reports/depositsattempts';
import { NewlyRecruitedCustomers } from '../../../Reports/newlyrecruitedcustomers';
import { ActiveCustomers } from '../../../Reports/activecustomers';
import { InActiveCustomers } from '../../../Reports/inactivecustomers';
import { InActiveCustomersMonth } from '../../../Reports/inactivecustomersovermonth';
import { CustomerCalledStatus } from '../../../users/customerstatus';
import { CustomerFeedBacks } from '../../../Reports/customerfeedbacks';
import { GamingIncomeMonthly } from '../../../Reports/gameincomemonthly';
import { RevenueChannelMonthly } from '../../../Reports/revenuechannelmonthly';
import { TimePlayedMonthly } from '../../../Reports/timeplayedmothly';
import { MTNAnalysisMonthly } from '../../../Reports/mtnanalysismonthly';
import { DepositAttemptsMonthly } from '../../../Reports/depositsattemptsmonthly';
import { WithdrawalSummaryMonthly } from '../../../Reports/withdawalsMonthly';
import { DailyDepositsMosntly } from '../../../Reports/dailydeposit';
import { PauStackMosntly } from '../../../Reports/paystacksmonthly';
import { JackPotCountMonthly } from '../../../Reports/jackpotcountmonthly';
import { BetsPerMonthly } from '../../../Bets/betsmonthly';
import { PlayedCustomers } from '../../../Reports/playedcustomers';
import { PlayedCustomersYesterday } from '../../../Reports/playedcustomersyestday';
import { PlayedCustomersFourTImes } from '../../../Reports/playedcustomersfourtimes';
import { PlayedCustomersThanFourMonth } from '../../../Reports/playedcustomersmorethanfourmonth';
import { DepositAttemptsCustomer } from '../../../Reports/customerdepositattemps';
import { NetCashFlow } from '../../../Reports/netcashflow';
import { sendSMSDateCreated } from '../../../Blasts/sendSMSDateCreated';
import { CustomerFullInfo } from '../../../Reports/customerfullinfo';
import { SocialMedia } from '../../../Reports/socialmediia';
import { CohortAnalysis } from '../../../Reports/cohortSend';
import { CustomerIncomingMessage } from '../../../Reports/CustomerincomingMessages';
import { CompaignRecruitment } from '../../../RadioCompaign/compaignrecruitment';
import { CompaignDeposits } from '../../../RadioCompaign/compaigndeposit';
import { CompaignBet } from '../../../RadioCompaign/compaignbet';
import { BetsPerAfterCall } from '../../../Bets/betsperdayaftercall';
import { DepositRequests_CustomerDeposits } from '../../../Finance/mtndeposits';
import { SubscriptionStatus } from '../../../Reports/subscriptionstatus';
import { DailyBilled } from '../../../Reports/dailybilled';
import { SubscriptionChannel } from '../../../Reports/subscriptionChannel.jsx';
import { SubscriptionNumbers } from '../../../Reports/SubscriptionNumbers.jsx';
import { SubscriptionsSDP } from '../../../Reports/subscriptionsSDP.jsx';

import { NewlyCustomerRecruitedDeposits } from '../../../Reports/newlycustomerrecruitedvsdeposit.jsx';
import { OutCustomerFeedBacks } from '../../../Reports/outcustomerfeedbacks.jsx';

import { activeDepositors } from '../../../Blasts/activeDepositors.js';
import LoginAudit from '../../../Reports/LoginAudit.jsx';
import CustomerAttandance from '../../../Reports/CustomerAttandance.jsx';
import OnlineNotifications from '../../../blackList/notifications.jsx';
import { BlastCountPlayed } from '../../../Blasts/countPlayed.js';
import { OnlinevsSMS } from '../../../Bets/OnlinevsSMS.jsx';
import { PromoCode } from '../../../users/promoCodes.jsx';
import { PromoCodeReferral } from '../../../Reports/promoCodeReferrals.jsx';
import { PromoCodeOnwers } from '../../../Reports/promocodeowners.jsx';
import FileUploadCall from '../../../CSV/call_assist.jsx';
import { CallAssist } from '../../../Reports/call_assist.jsx';
import { SetMiniJackPot } from '../../../users/setMiniJackpot.jsx';
import { reserveJackpot } from '../../../users/reseveJackpot.jsx';
import { neverDepositors } from '../../../Blasts/neverDepositors.jsx';
import { Secure_d } from '../../../Reports/secure_d.jsx';

import { ReferralIncome } from '../../../users/referralIncome.jsx';
import { secureDBlast } from '../../../Blasts/secureDBlast';
import { secureDBlastInactive } from '../../../Blasts/secureDBlastInactive';
import { SecureDAnalysis } from '../../../Reports/secureDAnalysis';
import { SecureDAChannel } from '../../../Reports/secureDAChannel.jsx';
import { Secure_d_Revenue } from '../../../Reports/secured_revenue.jsx';

import { Secure_d_Comparison } from '../../../Reports/secure_d_comparison';
import { Secure_d_Recruitment } from '../../../Reports/secure_d_recruitment.jsx';


export default () => (
  <Switch>

    <Route path="/referralstatement" component={ReferralIncome} exact />

    <Route path="/callassist" component={CallAssist} exact />
    <Route path="/promocodeowners" component={PromoCodeOnwers} />
    <Route path="/secured_r" component={Secure_d_Revenue} />

    <Route path="/summary" component={BetSummary} />
    <Route path="/eod" component={EOD} />

    <Route path="/call_assist_upload" component={FileUploadCall} />
    <Route path="/mini_jackpot" component={SetMiniJackPot} />

    <Route path="/reserve_jackpot" component={reserveJackpot} />

    <Route path="/secure_d" component={Secure_d} />

    <Route path="/secureblast" component={secureDBlast} />


    <Route path="/mtnanaylsis" component={MTNAnalysis} />
    <Route path="/gamingincome" component={GamingIncome} />
    <Route path="/revenuechannel" component={RevenueChannel} />
    <Route path="/withdrawalsummary" component={WithdrawalSummary} />

    <Route path="/customersubscription" component={CustomerSubscription} />

    <Route path="/timesplayed" component={TimePlayed} />
    <Route path="/never_deposited" component={neverDepositors} />

    <Route path="/uniquedepositor" component={DepositAttempts} />


    <Route path="/newlycustomer" component={NewlyRecruitedCustomers} />

    <Route path="/activecustomers" component={ActiveCustomers} />

    <Route path="/inactivecustomers" component={InActiveCustomers} />

    <Route path="/inactivecustomersmonth" component={InActiveCustomersMonth} />

    <Route path="/calledstatus" component={CustomerCalledStatus} />

    <Route path="/customerfeedback" component={CustomerFeedBacks} />

    <Route path="/compaignrecruitment" component={CompaignRecruitment} />

    <Route path="/compaigndeposit" component={CompaignDeposits} />
    <Route path="/compaignbet" component={CompaignBet} />


    <Route path="/incomemonthly" component={GamingIncomeMonthly} />

    <Route path="/revenuemonthly" component={RevenueChannelMonthly} />

    <Route path="/timeplayedmonthly" component={TimePlayedMonthly} />

    <Route path="/mtnepositmonthly" component={MTNAnalysisMonthly} />

    <Route path="/uniquedepositormonthly" component={DepositAttemptsMonthly} />

    <Route path="/depositsmonthly" component={DailyDepositsMosntly} />

    <Route path="/paystackmonthly" component={PauStackMosntly} />

    <Route path="/jackpotmonthly" component={JackPotCountMonthly} />

    <Route path="/betmonthly" component={BetsPerMonthly} />

    <Route path="/threedayscustomers" component={PlayedCustomers} />

    <Route path="/yesterdaycustomers" component={PlayedCustomersYesterday} />

    <Route path="/playforthtimescustomers" component={PlayedCustomersFourTImes} />

    <Route path="/playoveramonth" component={PlayedCustomersThanFourMonth} />

    <Route path="/depositattemptscustomer" component={DepositAttemptsCustomer} />

    <Route path="/netcashflow" component={NetCashFlow} />

    <Route path="/sendmonthly" component={sendSMSDateCreated} />

    <Route path="/customerfullinfo" component={CustomerFullInfo} />

    <Route path="/socialmediaposts" component={SocialMedia} />

    <Route path="/cohortAnalysis" component={CohortAnalysis} />

    <Route path="/customersaftercall" component={BetsPerAfterCall} />


    <Route path="/subscriptionstatus" component={SubscriptionStatus} />
    <Route path="/dsilybilled" component={DailyBilled} />

    <Route path="/active_blasts" component={activeDepositors} />


    <Route path="/customerincomingMessages" component={CustomerIncomingMessage} />

    <Route path="/mtndepositsrequests" component={DepositRequests_CustomerDeposits} />

    <Route path="/subscriptionsdpota" component={SubscriptionChannel} />
    <Route path="/subscriptionnumbers" component={SubscriptionNumbers} />
    <Route path="/subscriptionssdp" component={SubscriptionsSDP} />

    <Route path="/outgoingcustomerfeedbacks" component={OutCustomerFeedBacks} />


    <Route path="/newlyrecruitscustomer" component={NewlyCustomerRecruitedDeposits} />

    <Route path="/withdrawlsummarymonthly" component={WithdrawalSummaryMonthly} />

    <Route path="/audit" component={LoginAudit} />
    <Route path="/audit_performance" component={CustomerAttandance} />

    <Route path="/onlinenotifications" component={OnlineNotifications} />

    <Route path="/blastcountplayed" component={BlastCountPlayed} />

    <Route path="/onlinevsms" component={OnlinevsSMS} />

    <Route path="/promosearch" component={PromoCode} />

    <Route path="/promocodereferral" component={PromoCodeReferral} />

    <Route path="/secured_d_inactive" component={secureDBlastInactive} />

    <Route path='/secure_d_analysis' component={SecureDAnalysis} />

    <Route path='/secure_d_channel' component={SecureDAChannel} />

    <Route path='/secure_d_comparison' component={Secure_d_Comparison} />

    <Route path='/secure_d_recruitment' component={Secure_d_Recruitment} />

    

    


    {/* 
new Date(new Date().getFullYear(), new Date().getMonth(), 1)
new Date(new Date(new Date(new Date().getFullYear(), new Date().getMonth(), 1)))
 */}



  </Switch>
);
